











import Vue from "vue";
import Component from "vue-class-component";

import { Deck, LearningSession } from "../types";

import LearnComponent from "../components/learn/Learn.vue";

const LearnProps = Vue.extend({
  props: {
    decks: { type: Array as () => Deck[] },
    learningSession: { type: Object as () => LearningSession },
    numberOfSelectedDecks: Number,
    cardLimit: String
  }
});

@Component({
  components: {
    LearnComponent
  }
})
export default class Learn extends LearnProps {}
